// src/utils/ndmiColors.js

/**
 * Final 9-Step NDMI Color Scale
 * Labels are now translation keys
 */
export const ndmiColorScale = [
    { min: -1.0, max: -0.3, color: '#8B4513', labelKey: 'critical_stress' },
    { min: -0.3, max: -0.1, color: '#CD5C5C', labelKey: 'high_stress' },
    { min: -0.1, max: 0.0, color: '#FF8C00', labelKey: 'medium_stress' },
    { min: 0.0, max: 0.1, color: '#FFD700', labelKey: 'attention' },
    { min: 0.1, max: 0.2, color: '#F0E68C', labelKey: 'light_stress' },
    { min: 0.2, max: 0.3, color: '#87CEEB', labelKey: 'normal' },
    { min: 0.3, max: 0.4, color: '#4169E1', labelKey: 'good' },
    { min: 0.4, max: 0.5, color: '#0000CD', labelKey: 'very_good' },
    { min: 0.5, max: 1.1, color: '#00008B', labelKey: 'high_moisture' }
];

/**
 * Granular Color Ramp for RGB-to-Value interpolation
 */
export const ndmiColorRamp = [
    { ndmi: -0.50, color: '#8B4513' },
    { ndmi: -0.30, color: '#CD5C5C' },
    { ndmi: -0.10, color: '#FF8C00' },
    { ndmi: 0.00, color: '#FFD700' },
    { ndmi: 0.10, color: '#F0E68C' },
    { ndmi: 0.20, color: '#87CEEB' },
    { ndmi: 0.30, color: '#4169E1' },
    { ndmi: 0.40, color: '#0000CD' },
    { ndmi: 0.50, color: '#00008B' },
    { ndmi: 0.60, color: '#00008B' }
];

export const getNdmiColor = (ndmi) => {
    if (ndmi === null || ndmi === undefined) return '#cccccc';
    const range = ndmiColorScale.find(r => ndmi >= r.min && ndmi < r.max);
    if (range) return range.color;
    if (ndmi >= 0.5) return '#00008B';
    if (ndmi < -0.5) return '#8B4513';
    return '#cccccc';
};

/**
 * Get NDMI description with translation support
 * @param {number} ndmi - NDMI value
 * @param {function} t - Translation function from useTranslation (optional)
 * @returns {string} Translated description
 */
export const getNdmiDescription = (ndmi, t = null) => {
    if (ndmi === null || ndmi === undefined) {
        return t ? t('ndmi.no_data') : 'Veri Yok';
    }
    const range = ndmiColorScale.find(r => ndmi >= r.min && ndmi < r.max);
    if (range) {
        return t ? t(`ndmi.${range.labelKey}`) : range.labelKey;
    }
    return t ? t('ndmi.unknown') : 'Bilinmiyor';
};
